import _styled from "@emotion/styled-base";
import React from 'react';

var SectionTitleWrapper = _styled("div", {
  target: "e1m9pdeg0",
  label: "SectionTitleWrapper"
})(function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.primarySemiBold;
}, ";font-size:1.75rem;color:", function (_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  return theme.colors[variant] || theme.sectionTitle.textColor;
}, ";", function (_ref3) {
  var theme = _ref3.theme;
  return theme.MQ.M;
}, "{font-size:2.25rem;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9TZWN0aW9uVGl0bGUvaW5kZXguanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdzQyIsImZpbGUiOiIuLi8uLi9zcmMvU2VjdGlvblRpdGxlL2luZGV4LmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5jb25zdCBTZWN0aW9uVGl0bGVXcmFwcGVyID0gc3R5bGVkLmRpdmBcblx0JHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5mb250cy5wcmltYXJ5U2VtaUJvbGR9O1xuXHRmb250LXNpemU6IDEuNzVyZW07XG5cdGNvbG9yOiAkeyh7IHRoZW1lLCB2YXJpYW50IH0pID0+IHRoZW1lLmNvbG9yc1t2YXJpYW50XSB8fCB0aGVtZS5zZWN0aW9uVGl0bGUudGV4dENvbG9yfTtcblxuXHQkeyh7IHRoZW1lIH0pID0+IHRoZW1lLk1RLk19IHtcblx0XHRmb250LXNpemU6IDIuMjVyZW07XG5cdH1cbmBcblxuZXhwb3J0IGZ1bmN0aW9uIFNlY3Rpb25UaXRsZSh7IGNoaWxkcmVuLCBjbGFzc05hbWUsIHZhcmlhbnQgfSkge1xuXHRyZXR1cm4gKFxuXHRcdDxTZWN0aW9uVGl0bGVXcmFwcGVyIGNsYXNzTmFtZT17Y2xhc3NOYW1lfSB2YXJpYW50PXt2YXJpYW50fT5cblx0XHRcdHtjaGlsZHJlbn1cblx0XHQ8L1NlY3Rpb25UaXRsZVdyYXBwZXI+XG5cdClcbn1cbiJdfQ== */"));

export function SectionTitle(_ref4) {
  var children = _ref4.children,
      className = _ref4.className,
      variant = _ref4.variant;
  return /*#__PURE__*/React.createElement(SectionTitleWrapper, {
    className: className,
    variant: variant
  }, children);
}